"use strict";
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

export default (function () {

    
    toggleEyePassword();

    //Cleaning state of side menu
    localStorage.setItem("drawerActive", "");

    function toggleEyePassword() {
        const togglePasswordIcon = document.querySelector(".js-password-icon");
        const passwordInput = document.querySelector(".js-password-input");

        if (togglePasswordIcon) {
            togglePasswordIcon.addEventListener("click", function () {
                const type = passwordInput.getAttribute("type") === "password" ? "text" : "password";
                passwordInput.setAttribute("type", type);

                const eyeHideIcon = document.querySelector(".eye-hide");
                eyeHideIcon.classList.toggle("d-none");

                const eyeShowIcon = document.querySelector(".eye-show");
                eyeShowIcon.classList.toggle("d-none");
            });
        }
    }

    $("#account").submit(function () {
        if ($(this).valid()) {
            spinnerOn("submitButton");
        }
    });

}());
